import { FormBase } from 'core/components';

export default class FacilityOrderTemplateNewFlowCustomOrderingDoctorChangeForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'customOrderingDoctorId',
                    label: 'Provider',
                    placeholder: 'Select Provider',
                    rules: 'required|string'            
                },
            ],
        };
    }
}
